import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getuserdata } from "../../../services/apiService";
import { oneKlicks } from "../../../SDK/oneclick";
import ImageShow from "../../../Uitiles/ImageShow";
import { Badge } from "react-bootstrap";

const HospitalCardViews = () => {
    const navigate = useNavigate();
    const [hospital, setHospital] = useState({});
    const [metrics, setMetrics] = useState({
        totalDoctors: 0,
        totalAppointments: 0,
        newMessages: 0,
        savedItems: 0,
        teamMembers: 0,
        totalRevenue: 0
    });
    const [recentAppointments, setRecentAppointments] = useState([]);
    const [recentPayments, setRecentPayments] = useState([]);
    const [loadingAppointments, setLoadingAppointments] = useState(false);
    const [loadingPayments, setLoadingPayments] = useState(false);

    useEffect(() => {
        getHospitalData();
        fetchMetrics();
        fetchRecentAppointments();
        fetchRecentPayments();
    }, []);

    const getHospitalData = async () => {
        const hospitalData = await getuserdata("full");
        setHospital(hospitalData);
    };

    const fetchMetrics = async () => {
        try {
            const hospitalData = await getuserdata("full");
            if (!hospitalData?.id) {
                console.log('❌ No hospital ID found');
                return;
            }

            console.log('🏥 Fetching metrics for hospital ID:', hospitalData.id);

            // Fetch total doctors (removed status filter to show all doctors)
            const doctorsResponse = await oneKlicks.read(
                "",
                "hospital_doctors",
                { hospital_id: hospitalData.id },
                "",
                "",
                "",
                []
            );
            console.log('👨‍⚕️ Doctors Response:', doctorsResponse);
            console.log('👨‍⚕️ Doctors Data Array:', doctorsResponse?.data);
            console.log('👨‍⚕️ Doctors Count:', doctorsResponse?.data?.length);
            const totalDoctors = doctorsResponse?.data?.length || 0;

            // Fetch total appointments
            const appointmentsResponse = await oneKlicks.read(
                "",
                "appointments",
                { hospital_id: hospitalData.id },
                "",
                "",
                "",
                []
            );
            console.log('📅 Appointments Response:', appointmentsResponse);
            console.log('📅 Appointments Data Array:', appointmentsResponse?.data);
            console.log('📅 Appointments Count:', appointmentsResponse?.data?.length);
            const totalAppointments = appointmentsResponse?.data?.length || 0;

            // Calculate total revenue from completed/paid appointments (including offline/hospital payments)
            let totalRevenue = 0;
            if (appointmentsResponse?.data) {
                totalRevenue = appointmentsResponse.data
                    .filter(apt => {
                        const isCompleted = apt.payment_status === 'completed' || apt.payment_status === 'paid';
                        const isHospitalPayment = apt.payment_mode === 'hospital';
                        const isApprovedHospitalPayment = apt.hospital_payment_status === 'approved';
                        return isCompleted || isHospitalPayment || isApprovedHospitalPayment;
                    })
                    .reduce((sum, apt) => {
                        const amount = parseFloat(apt.amount || apt.base_amount || 0);
                        return sum + amount;
                    }, 0);
            }
            console.log('💰 Total Revenue (including offline payments):', totalRevenue);

            // Use the same doctors count for team members (since team = doctors)
            const totalTeamMembers = totalDoctors;

            console.log('✅ Final Metrics:', {
                totalDoctors,
                totalAppointments,
                teamMembers: totalTeamMembers,
                totalRevenue
            });

            setMetrics({
                totalDoctors,
                totalAppointments,
                newMessages: 0, // You can fetch from messages table
                savedItems: 0, // You can fetch from saved items table
                teamMembers: totalTeamMembers,
                totalRevenue
            });
        } catch (error) {
            console.error("❌ Error fetching metrics:", error);
        }
    };

    const fetchRecentAppointments = async () => {
        try {
            setLoadingAppointments(true);
            const hospitalData = await getuserdata("full");
            if (!hospitalData?.id) {
                console.log('No hospital data found');
                setLoadingAppointments(false);
                return;
            }

            console.log('Fetching appointments for hospital:', hospitalData.id);

            // Try to fetch appointments directly by hospital_id first
            let appointmentsResponse = await oneKlicks.read(
                "",
                "appointments",
                { hospital_id: hospitalData.id },
                "id DESC",
                "",
                { page: 1, limit: 5 },
                [
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "patient_id",
                        target_label: "patient"
                    },
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "doctor_id",
                        target_label: "doctor"
                    }
                ]
            );

            console.log('Direct hospital appointments response:', appointmentsResponse);

            // If no appointments found by hospital_id, try fetching by doctor IDs
            if (!appointmentsResponse?.data || appointmentsResponse.data.length === 0) {
                console.log('No direct appointments, trying via doctors...');

                // Get all doctors associated with this hospital
                const doctorsResponse = await oneKlicks.read(
                    "",
                    "hospital_doctors",
                    { hospital_id: hospitalData.id, status: "Active" },
                    "",
                    "",
                    "",
                    []
                );

                console.log('Hospital doctors response:', doctorsResponse);

                if (!doctorsResponse?.data || doctorsResponse.data.length === 0) {
                    console.log('No doctors found for this hospital');
                    setRecentAppointments([]);
                    setLoadingAppointments(false);
                    return;
                }

                // Get all doctor IDs
                const doctorIds = doctorsResponse.data.map(d => d.doctor_id);
                console.log('Doctor IDs:', doctorIds);

                // Fetch appointments for these doctors
                const allAppointmentsResponse = await oneKlicks.read(
                    "",
                    "appointments",
                    {},
                    "id DESC",
                    "",
                    { page: 1, limit: 100 },
                    [
                        {
                            target_table: "users",
                            target_column: "id",
                            target_value: "patient_id",
                            target_label: "patient"
                        },
                        {
                            target_table: "users",
                            target_column: "id",
                            target_value: "doctor_id",
                            target_label: "doctor"
                        }
                    ]
                );

                console.log('All appointments response:', allAppointmentsResponse);

                if (allAppointmentsResponse?.success && allAppointmentsResponse?.data) {
                    // Filter appointments by doctor IDs
                    const filteredAppointments = allAppointmentsResponse.data.filter(apt =>
                        doctorIds.includes(apt.doctor_id)
                    ).slice(0, 5);

                    console.log('Filtered appointments:', filteredAppointments);
                    setRecentAppointments(filteredAppointments);
                } else {
                    setRecentAppointments([]);
                }
            } else {
                // Use direct hospital appointments
                console.log('Using direct hospital appointments:', appointmentsResponse.data);
                setRecentAppointments(appointmentsResponse.data);
            }
        } catch (error) {
            console.error("Error fetching recent appointments:", error);
            setRecentAppointments([]);
        } finally {
            setLoadingAppointments(false);
        }
    };

    const fetchRecentPayments = async () => {
        try {
            setLoadingPayments(true);
            const hospitalData = await getuserdata("full");
            if (!hospitalData?.id) {
                console.log('No hospital data found for payments');
                setLoadingPayments(false);
                return;
            }

            console.log('Fetching payments for hospital:', hospitalData.id);

            // Fetch all appointments with payment details (including offline/hospital payments)
            const paymentsResponse = await oneKlicks.read(
                "",
                "appointments",
                {
                    hospital_id: hospitalData.id
                },
                "id DESC",
                "",
                { page: 1, limit: 50 }, // Increased limit to get more records before filtering
                [
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "patient_id",
                        target_label: "patient"
                    },
                    {
                        target_table: "users",
                        target_column: "id",
                        target_value: "doctor_id",
                        target_label: "doctor"
                    }
                ]
            );

            console.log('Payments response:', paymentsResponse);

            if (paymentsResponse?.success && paymentsResponse?.data) {
                // Filter for:
                // 1. Completed/paid online payments
                // 2. Hospital/offline payments (payment_mode = 'hospital')
                // 3. Approved hospital payments (hospital_payment_status = 'approved')
                const paidAppointments = paymentsResponse.data.filter(apt => {
                    const isCompleted = apt.payment_status === 'completed' || apt.payment_status === 'paid';
                    const isHospitalPayment = apt.payment_mode === 'hospital';
                    const isApprovedHospitalPayment = apt.hospital_payment_status === 'approved';

                    return isCompleted || isHospitalPayment || isApprovedHospitalPayment;
                }).slice(0, 10); // Take only the 10 most recent

                console.log('Filtered paid appointments (including offline):', paidAppointments);
                setRecentPayments(paidAppointments);
            } else {
                setRecentPayments([]);
            }
        } catch (error) {
            console.error("Error fetching recent payments:", error);
            setRecentPayments([]);
        } finally {
            setLoadingPayments(false);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        try {
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return "N/A";
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch (error) {
            return "N/A";
        }
    };

    const getStatusBadge = (status) => {
        const statusLower = (status || "").toLowerCase();
        let variant = "secondary";
        if (statusLower === "confirmed" || statusLower === "upcoming") variant = "success";
        else if (statusLower === "pending") variant = "warning";
        else if (statusLower === "completed" || statusLower === "done") variant = "info";
        else if (statusLower === "cancelled" || statusLower === "canceled") variant = "danger";

        return <Badge bg={variant} style={{ borderRadius: '4px', padding: '5px 10px', fontSize: '11px', fontWeight: '600' }}>{status || "Unknown"}</Badge>;
    };

    return (
        <section className="dc-haslayout dc-dbsectionspace">
            <div className="row">
                <div className="dc-haslayout dc-jobpostedholder">
                    {/* Total Doctors Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">{metrics.totalDoctors}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2025/02/Management-Team-Line-Icon-Graphi.png" alt="Total Doctors" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Total Doctors</h3>
                                    <Link to="/hospital/mydoctors">Manage Doctors</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Total Appointments Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">{metrics.totalAppointments}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png" alt="Total Appointments" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Total Appointments</h3>
                                    <Link to="/hospital/appointmentlist">View All Appointments</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Revenue Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">₹{metrics.totalRevenue.toLocaleString('en-IN')}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png" alt="Total Revenue" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Total Revenue</h3>
                                    <Link to="#revenue-section">View Payments</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* New Messages Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">{metrics.newMessages}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2025/02/5356190.png" alt="New Messages" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>New Messages</h3>
                                    <Link to="/hospital/inbox">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Saved Items Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">{metrics.savedItems}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/08/img-22.png" alt="Save Items" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>View Saved Items</h3>
                                    <Link to="/hospital/mysaveditems">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Manage Team Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">{metrics.teamMembers}</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2025/02/Management-Team-Line-Icon-Graphi.png" alt="Manage Team" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Manage Team</h3>
                                    <Link to="/hospital/manageteam">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Specialties and Services Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">0</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/10/support.png" alt="Specialties and Services" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Manage Specialties and Services</h3>
                                    <Link to="/hospital/specialitiesservices">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Profile Settings Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">0</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/10/list.png" alt="Profile Settings" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Profile Settings</h3>
                                    <Link to="/hospital/profilesettings/Hospital_Profile_Settings">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Invoices Card */}
                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                        <div className="dc-insightsitem dc-dashboardbox" style={{ minHeight: '180px', display: 'flex', flexDirection: 'column' }}>
                            <span><em className="dcunread-count">0</em></span>
                            <figure className="dc-userlistingimg">
                                <img src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png" alt="Invoices" />
                            </figure>
                            <div className="dc-insightdetails" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <div className="dc-title">
                                    <h3 style={{ minHeight: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Check Your Invoices</h3>
                                    <Link to="/hospital/invoices">Click To View</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recent Appointments Table */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <style>
                        {`
                            @media (max-width: 767px) {
                                .dc-table-responsive thead {
                                    display: none;
                                }
                                .dc-table-responsive tbody tr {
                                    display: block;
                                    margin-bottom: 20px;
                                    border: 1px solid #eee;
                                    border-radius: 10px;
                                    background: #fff;
                                    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
                                    padding: 10px;
                                }
                                .dc-table-responsive tbody td {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 12px 15px !important;
                                    border-bottom: 1px solid #f5f5f5;
                                    text-align: right;
                                    font-size: 13px;
                                    min-height: 45px;
                                }
                                .dc-table-responsive tbody td:last-child {
                                    border-bottom: 0;
                                    margin-top: 10px;
                                }
                                .dc-table-responsive tbody td::before {
                                    content: attr(data-label);
                                    font-weight: 700;
                                    color: #666;
                                    text-transform: uppercase;
                                    font-size: 10px;
                                    letter-spacing: 0.5px;
                                    text-align: left;
                                    flex: 1;
                                }
                                .dc-table-responsive .d-flex.align-items-center {
                                    justify-content: flex-end;
                                    width: 100%;
                                }
                            }
                        `}
                    </style>
                    <div className="dc-dashboardbox dc-dashboardtabsholder">
                        <div className="dc-dashboardboxtitle">
                            <h2>Recent Appointments</h2>
                        </div>
                        {loadingAppointments ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem', borderColor: 'var(--themecolor)', borderRightColor: 'transparent' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading appointments...</p>
                            </div>
                        ) : recentAppointments.length > 0 ? (
                            <div className="dc-dashboardboxcontent p-0">
                                <div className="table-responsive">
                                    <table className="table mb-0 align-middle dc-table-responsive">
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>ID</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Patient</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Doctor</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Schedule</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Status</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666', textAlign: 'right' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recentAppointments.map((appointment) => {
                                                const patient = appointment.patient?.[0] || {};
                                                const doctor = appointment.doctor?.[0] || {};

                                                return (
                                                    <tr key={appointment.id}>
                                                        <td data-label="ID" style={{ padding: '12px 20px', fontSize: '13px', color: '#999' }}>#{appointment.id}</td>
                                                        <td data-label="Patient" style={{ padding: '12px 20px' }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <ImageShow
                                                                    url={patient.profile_photo_url || '/default-avatar.png'}
                                                                    width={35}
                                                                    height={35}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #eee'
                                                                    }}
                                                                />
                                                                <div className="text-end text-md-start">
                                                                    <div style={{ fontWeight: '600', color: '#333', fontSize: '13px', lineHeight: '1.2' }}>
                                                                        {patient.display_name || patient.first_name + ' ' + patient.last_name || 'N/A'}
                                                                    </div>
                                                                    <div style={{ fontSize: '11px', color: '#999' }}>{patient.email || ''}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Doctor" style={{ padding: '12px 20px' }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <ImageShow
                                                                    url={doctor.profile_photo_url || '/default-avatar.png'}
                                                                    width={35}
                                                                    height={35}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #eee'
                                                                    }}
                                                                />
                                                                <div className="text-end text-md-start">
                                                                    <div style={{ fontWeight: '600', color: '#333', fontSize: '13px', lineHeight: '1.2' }}>
                                                                        {doctor.display_name || 'N/A'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Schedule" style={{ padding: '12px 20px' }}>
                                                            <div className="text-end">
                                                                <div style={{ fontSize: '13px', fontWeight: '500' }}>{formatDate(appointment.appointment_date)}</div>
                                                                <div style={{ fontSize: '11px', color: '#999' }}>{appointment.appointment_time || "N/A"}</div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Status" style={{ padding: '12px 20px' }}>{getStatusBadge(appointment.status)}</td>
                                                        <td data-label="Action" style={{ padding: '12px 20px', textAlign: 'right' }}>
                                                            <Link
                                                                to={`/hospital/appointmentlist?id=${appointment.id}`}
                                                                className="btn btn-sm btn-primary"
                                                                style={{
                                                                    backgroundColor: 'var(--themecolor)',
                                                                    borderColor: 'var(--themecolor)',
                                                                    borderRadius: '4px',
                                                                    fontSize: '12px',
                                                                    padding: '4px 12px'
                                                                }}
                                                            >
                                                                View
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="p-4 text-right" style={{ borderTop: '1px solid #eee', background: '#fcfcfc' }}>
                                    <Link
                                        to="/hospital/appointmentlist"
                                        className="btn dc-btn-view-all"
                                        style={{
                                            backgroundColor: 'var(--themecolor)',
                                            color: '#fff',
                                            padding: '12px 35px',
                                            borderRadius: '5px',
                                            fontWeight: '700',
                                            fontSize: '14px',
                                            textTransform: 'uppercase',
                                            letterSpacing: '1px',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                            border: '2px solid var(--themecolor)',
                                            textDecoration: 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#fff';
                                            e.currentTarget.style.color = 'var(--themecolor)';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.15)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'var(--themecolor)';
                                            e.currentTarget.style.color = '#fff';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                                        }}
                                    >
                                        <span>View All Appointments</span>
                                        <i className="ti-arrow-right" style={{ fontSize: '16px' }}></i>
                                    </Link>
                                </div>
                            </div>
                        ) : (
                            <div className="dc-emptydata-holder">
                                <div className="dc-emptydata">
                                    <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                                        <span></span>
                                        <em>There are no appointments.</em>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Recent Payments Section */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="revenue-section">
                    <div className="dc-dashboardbox dc-dashboardtabsholder" style={{ marginTop: '30px' }}>
                        <div className="dc-dashboardboxtitle">
                            <h2>Recent Payments</h2>
                        </div>
                        {loadingPayments ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status" style={{ width: '2rem', height: '2rem', borderColor: 'var(--themecolor)', borderRightColor: 'transparent' }}>
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading payments...</p>
                            </div>
                        ) : recentPayments.length > 0 ? (
                            <div className="dc-dashboardboxcontent p-0">
                                <div className="table-responsive">
                                    <table className="table mb-0 align-middle dc-table-responsive">
                                        <thead className="bg-light">
                                            <tr>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>ID</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Patient</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Doctor</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Date</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Amount</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Payment Status</th>
                                                <th style={{ padding: '12px 20px', fontSize: '13px', fontWeight: '600', color: '#666' }}>Payment Mode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recentPayments.map((payment) => {
                                                const patient = payment.patient?.[0] || {};
                                                const doctor = payment.doctor?.[0] || {};
                                                const amount = parseFloat(payment.amount || payment.base_amount || 0);

                                                return (
                                                    <tr key={payment.id}>
                                                        <td data-label="ID" style={{ padding: '12px 20px', fontSize: '13px', color: '#999' }}>#{payment.id}</td>
                                                        <td data-label="Patient" style={{ padding: '12px 20px' }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <ImageShow
                                                                    url={patient.profile_photo_url || '/default-avatar.png'}
                                                                    width={35}
                                                                    height={35}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #eee'
                                                                    }}
                                                                />
                                                                <div className="text-end text-md-start">
                                                                    <div style={{ fontWeight: '600', color: '#333', fontSize: '13px', lineHeight: '1.2' }}>
                                                                        {patient.display_name || patient.first_name + ' ' + patient.last_name || 'N/A'}
                                                                    </div>
                                                                    <div style={{ fontSize: '11px', color: '#999' }}>{patient.phone || patient.email || ''}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Doctor" style={{ padding: '12px 20px' }}>
                                                            <div className="d-flex align-items-center gap-2">
                                                                <ImageShow
                                                                    url={doctor.profile_photo_url || '/default-avatar.png'}
                                                                    width={35}
                                                                    height={35}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        borderRadius: '50%',
                                                                        border: '1px solid #eee'
                                                                    }}
                                                                />
                                                                <div className="text-end text-md-start">
                                                                    <div style={{ fontWeight: '600', color: '#333', fontSize: '13px', lineHeight: '1.2' }}>
                                                                        {doctor.display_name || 'N/A'}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Date" style={{ padding: '12px 20px' }}>
                                                            <div className="text-end">
                                                                <div style={{ fontSize: '13px', fontWeight: '500' }}>{formatDate(payment.appointment_date)}</div>
                                                                <div style={{ fontSize: '11px', color: '#999' }}>{payment.appointment_time || "N/A"}</div>
                                                            </div>
                                                        </td>
                                                        <td data-label="Amount" style={{ padding: '12px 20px' }}>
                                                            <div style={{ fontSize: '14px', fontWeight: '700', color: '#28a745' }}>
                                                                ₹{amount.toLocaleString('en-IN')}
                                                            </div>
                                                        </td>
                                                        <td data-label="Payment Status" style={{ padding: '12px 20px' }}>
                                                            {(() => {
                                                                const isHospitalPayment = payment.payment_mode === 'hospital';
                                                                const isApproved = payment.hospital_payment_status === 'approved';
                                                                const isPending = payment.payment_status === 'pending';

                                                                let badgeVariant = 'success';
                                                                let statusText = payment.payment_status || 'Paid';

                                                                if (isHospitalPayment) {
                                                                    if (isApproved) {
                                                                        badgeVariant = 'success';
                                                                        statusText = 'Approved (Offline)';
                                                                    } else if (isPending) {
                                                                        badgeVariant = 'warning';
                                                                        statusText = 'Pending (Offline)';
                                                                    } else {
                                                                        badgeVariant = 'info';
                                                                        statusText = 'Hospital Payment';
                                                                    }
                                                                }

                                                                return (
                                                                    <Badge
                                                                        bg={badgeVariant}
                                                                        style={{
                                                                            borderRadius: '4px',
                                                                            padding: '5px 10px',
                                                                            fontSize: '11px',
                                                                            fontWeight: '600'
                                                                        }}
                                                                    >
                                                                        {statusText}
                                                                    </Badge>
                                                                );
                                                            })()}
                                                        </td>
                                                        <td data-label="Payment Mode" style={{ padding: '12px 20px' }}>
                                                            <span style={{ fontSize: '13px', textTransform: 'capitalize' }}>
                                                                {payment.payment_mode || payment.payment_method || 'N/A'}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <div className="dc-emptydata-holder">
                                <div className="dc-emptydata">
                                    <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                                        <span></span>
                                        <em>No payment records found.</em>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HospitalCardViews;
